module.exports = __webpack_public_path__ + "static/media/co_hasta200.377b6063.png";